import React from 'react';

import isEmpty from 'lodash/fp/isEmpty';
import map from 'lodash/fp/map';

import { reducer as articleReducer } from '@lumapps/articles/ducks/slice';
import { useDataAttributes } from '@lumapps/data-attributes';
import { Button, Dropdown, Icon, List, ListItem, Placement, Size } from '@lumapps/lumx/react';
import { injectReducer } from '@lumapps/redux/manager';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { useBooleanState } from '@lumapps/utils/hooks/useBooleanState';

import { useSpaceContributionButton } from '../../hooks/useSpaceContributionButton';

injectReducer('articles', articleReducer);

const SCOPE = 'space-contribution';

export const SpaceContributionButton = () => {
    const dropdownAnchor = React.useRef(null);
    const [isDropdownOpen, toggleDropdown, closeDropdown] = useBooleanState(false);
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(SCOPE);

    const { menuItems, dialogs } = useSpaceContributionButton();

    if (isEmpty(menuItems)) {
        return dialogs;
    }

    if (menuItems.length === 1) {
        const { key, onClick, ref, tooltipLabelKey } = menuItems[0];

        return (
            <>
                <Button
                    {...get({ element: 'button', action: `create-${key}` })}
                    onClick={onClick}
                    ref={ref}
                    title={translateKey(tooltipLabelKey)}
                >
                    {translateKey(GLOBAL.CREATE)}
                </Button>
                {dialogs}
            </>
        );
    }

    return (
        <>
            <Button {...get({ element: 'button', action: 'open-menu' })} ref={dropdownAnchor} onClick={toggleDropdown}>
                {translateKey(GLOBAL.CREATE)}
            </Button>
            <Dropdown
                isOpen={isDropdownOpen}
                onClose={closeDropdown}
                anchorRef={dropdownAnchor}
                placement={Placement.BOTTOM_END}
            >
                <List>
                    {map(
                        ({ key, labelKey, tooltipLabelKey, icon, onClick }) => (
                            <ListItem
                                {...get({ element: 'menu-item', action: `create-${key}` })}
                                key={key}
                                title={translateKey(tooltipLabelKey)}
                                size="tiny"
                                before={<Icon icon={icon} size={Size.xs} />}
                                onItemSelected={onClick}
                            >
                                {translateKey(labelKey)}
                            </ListItem>
                        ),
                        menuItems,
                    )}
                </List>
            </Dropdown>
            {dialogs}
        </>
    );
};
